import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Copy,
  QR as QRCode,
  Flex,
  Image,
  Button,
  IconButton,
} from '@elparking/components'
import { FormattedMessage, injectIntl } from 'react-intl'
import mobileIcon from './mobile_icon.svg'
import alert from './alert.svg'
import styled from 'styled-components'
export const CloseButtonContainer = styled.div`
  position: absolute;
  top: 14px;
  right: 0.5em;
`
export const AlertButtonContainer = styled(Flex)`
  align-content: flex-start;
`
export const DownloadAppButton = styled(Button)`
  align-content: center;
`

const RegisterOnMobileBlock = ({
  onClose,
  mobileAppDeepLink,
  mobileImage,
  alertImage,
}) => {
  return (
    <Box mt={['0px', '3em']} flexDirection="column">
      <Flex justifyContent="flex-start">
        <CloseButtonContainer>
          <IconButton
            padding="10px"
            type="x"
            size="xLarge"
            color="gray"
            onClick={onClose}
          />
        </CloseButtonContainer>
      </Flex>
      <Flex w="100%" justifyContent="center">
        {mobileImage}
      </Flex>
      <Copy
        size={['large', 'xxLarge']}
        fontWeight="medium"
        textAlign="center"
        color="accent"
        padding="1em 0em"
      >
        <FormattedMessage defaultMessage="Regístrate en MutuaMás" />
      </Copy>
      <Copy
        fontSize="medium"
        textAlign="center"
        padding="1em"
        fontWeight="regular"
        display={['none', 'block']}
      >
        <FormattedMessage defaultMessage="Descarga ya en tu móvil la app MutuaMás para poder finalizar tu compra. Escanea con tu móvil este QR." />
      </Copy>
      <Copy
        fontSize="medium"
        textAlign="center"
        padding="1em"
        fontWeight="regular"
        display={['block', 'none']}
      >
        <FormattedMessage defaultMessage="Descarga ya en tu móvil la app MutuaMás para poder finalizar tu compra." />
      </Copy>
      {mobileAppDeepLink && (
        <Box textAlign="center" mt={['1em', '1em', '0']} mb="1em">
          <Box display={['none', 'block']}>
            <QRCode value={mobileAppDeepLink} size={100} />
          </Box>
          <Box display={['block', 'none']}>
            <DownloadAppButton
              rel="noopener noreferrer"
              href={mobileAppDeepLink}
              target="_blank"
              as="a"
              width="100%"
              display="flow"
            >
              <Copy color="white" padding="0">
                <FormattedMessage defaultMessage="Descargar la app" />
              </Copy>
            </DownloadAppButton>
          </Box>
        </Box>
      )}
      <Flex
        width="100%"
        padding="0.5em"
        alignItems="center"
        flexDirection="row"
        backgroundColor="accent10"
      >
        <AlertButtonContainer
          w="fit-content"
          marginRight="1em"
          height="100px"
          alignContent="start"
          flexWrap="wrap"
        >
          {alertImage}
        </AlertButtonContainer>
        <Flex flexDirection="column">
          <Copy fontWeight="bold" padding="0" mb="0.5em">
            <FormattedMessage defaultMessage="¿Eres Mutualista?" />{' '}
          </Copy>
          <Copy fontWeight="regular" padding="0" mb="0.5em">
            <FormattedMessage defaultMessage="Recuerda que si accedes a los canales de Mutua con tu correo y contraseña, puedes acceder a MutuaMás con las mismas claves." />{' '}
          </Copy>
          <Button.unstyled
            width="fit-content"
            onClick={onClose}
            padding="0"
            mb="0.5em"
            dataTest="register-modal-access-button"
          >
            <Copy
              as="a"
              fontColor="main"
              decoration="none"
              fontWeight="medium"
              fontSize="small"
              transform="none"
            >
              <FormattedMessage defaultMessage="Acceder" />{' '}
            </Copy>
          </Button.unstyled>
        </Flex>
      </Flex>
    </Box>
  )
}
RegisterOnMobileBlock.defaultProps = {
  onClose: () => {},
  mobileImage: (
    <Image
      src={mobileIcon}
      width="128px"
      height="128px"
      alignSelf="center"
      alt="ad"
    />
  ),
  alertImage: (
    <Image src={alert} width="32px" height="32px" alignSelf="center" alt="ad" />
  ),
}

RegisterOnMobileBlock.propTypes = {
  onClose: PropTypes.func,
  mobileAppDeepLink: PropTypes.string,
  mobileImage: PropTypes.node,
  alertImage: PropTypes.node,
}
export default injectIntl(RegisterOnMobileBlock)
